$(document).on('ajax:success', '.pagination__button', function (event) {
  const response = event.detail[0]
  if (response.event) {
    $('.js-events-pagination-container').append(response.template)
    $('#events_pagination').replaceWith(response.pagination)
  } else {
    $('#events_pagination').replaceWith(response.template)
  }
})

$('.events-nav__inner').on('change', '#q_event_type_id_eq', function () {
  $(this).closest('form').submit()
})
